import * as React from "react";

const Accordian1 = ({ color = "#61FF00" }) => (
  <svg width={1238} height={108} fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M39.015 1 1 37.074v69.626l794.5-.001m407.6 0 34.4-46.198V1h-384"
      stroke={color}
    />
  </svg>
);

export default Accordian1;
